import styled from 'styled-components';

var selectableWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__selectableWrapper",
  componentId: "sc-16olrvf-0"
})(["display:flex;align-items:center;button{box-sizing:border-box;}"]);

export { selectableWrapper };
